// Who may send documents to Tally by hand (Push to Tally, Retry): admins and
// these people. Keep in step with can_push_to_tally in backend/tally_bridge.py,
// which enforces it.
export const TALLY_PUSH_EMAILS = ["shilpa@canares.com", "priyanka@canares.com", "jaikanth@canares.com"];

export const canPushToTally = (user) =>
  user?.role === "admin" || TALLY_PUSH_EMAILS.includes((user?.email || "").trim().toLowerCase());
